import React, {Component} from "react";
import Dispute from "../dispute.components"
class DisputeFilter extends Component {
    constructor(props) {
        super(props);
        this.state={
            viewPage:true
        }
    }

    render(){
        const { viewPage } = this.state;
        const { disputeID, invoiceAuditID } = this.props.match.params;
        return(
            <>
                <Dispute viewDetailPage={viewPage} detailsDisputeID={disputeID} invoiceAuditID={invoiceAuditID} />
            </>
        )
    }
}

export default DisputeFilter